<template>
    <div> 
     <!--   <div v-if="!this.$route.path.includes('property') && !this.$route.path.includes('commercial')" class="fixed-tags" style="background-color: #e00233; padding: 10px; position: fixed; bottom: 10px; right: 10px; z-index: 1000;">
            <a style="color: #fff;" href="https://wa.me/27832581212" target="_blank">
                <i class="bi bi-whatsapp"></i> &nbsp;<strong>GET IN TOUCH</strong>
            </a>
        </div> -->

    </div>
</template>
<script>

import Menu from '@/components/Menu.vue'
import Search from '@/components/Search.vue'
import FeaturedProperty from '@/components/FeaturedProperty.vue'

export default {
  components: {
    Menu, Search, FeaturedProperty
  },
  mounted() {
    console.log(this.$route.path.includes('property'))
    console.log(this.$route.path.includes('commercial'))
  },
  data() {
    return {
      data: {
        listings: []
      }
    }
  },
  methods: {
    toggleType(type) {
      if (type === 'buy' || type === 'rent') {
        this.$store.commit('setFilter', { filter: 'buy', value: type === 'buy' });
        this.$store.commit('setFilter', { filter: 'rent', value: type === 'rent' });
        this.$store.commit('setMaxPrice', this.maxPrice);
        this.selectedType = this.selectedType === type ? null : type;
      }
      console.log(this.$store.state.search)
    },
    toggleLocation(location) {
      console.log(location)
    },
  }
}
</script>